import { api } from 'utils/apis/api';
const baseUrl = '/v2/messengers';
const mkSecretsUrl = (messengerId) => `${baseUrl}/${messengerId}/secrets`;
const mkSecretUrl = (messengerId, secretId) => `${mkSecretsUrl(messengerId)}/${secretId}`;
const apiWithTags = api.enhanceEndpoints({ addTagTypes: ['MessengerSecret'] });
export const messengersApi = apiWithTags.injectEndpoints({
    endpoints: (builder) => ({
        createSecret: builder.mutation({
            query: ({ messengerId, secret, description }) => {
                const data = {
                    encryption_type: 'jwe_symmetric',
                    secret,
                    description,
                };
                return {
                    path: mkSecretsUrl(messengerId),
                    method: 'POST',
                    body: data,
                };
            },
            transformResponse: (response) => {
                const data = response;
                return {
                    id: data.id,
                    createdAt: data.created_at,
                    description: data.description,
                };
            },
            invalidatesTags: (_result, error, arg) => error ? [] : [{ type: 'MessengerSecret', id: arg.messengerId }],
        }),
        readSecrets: builder.query({
            query: ({ messengerId }) => ({ path: mkSecretsUrl(messengerId) }),
            transformResponse: (response) => {
                return response.map((x) => ({
                    id: x.id,
                    createdAt: x.created_at,
                    description: x.description,
                }));
            },
            providesTags: (_result, _error, arg) => [
                { type: 'MessengerSecret', id: arg.messengerId },
            ],
        }),
        updateSecret: builder.mutation({
            query: ({ messengerId, secretId, description }) => {
                const data = {
                    description,
                };
                return {
                    path: mkSecretUrl(messengerId, secretId),
                    method: 'PUT',
                    body: data,
                };
            },
            transformResponse: (response) => {
                const data = response;
                return {
                    id: data.id,
                    createdAt: data.created_at,
                    description: data.description,
                };
            },
            invalidatesTags: (_result, error, arg) => error ? [] : [{ type: 'MessengerSecret', id: arg.messengerId }],
        }),
        deleteSecret: builder.mutation({
            query: ({ messengerId, secretId }) => {
                return {
                    path: mkSecretUrl(messengerId, secretId),
                    method: 'DELETE',
                };
            },
            invalidatesTags: (_result, error, arg) => error ? [] : [{ type: 'MessengerSecret', id: arg.messengerId }],
        }),
        generateSecret: builder.mutation({
            query: () => {
                const data = {
                    algorithm: 'A256CBC-HS512',
                };
                return {
                    path: `${baseUrl}/generate-secret`,
                    method: 'POST',
                    body: data,
                };
            },
        }),
        decryptToken: builder.mutation({
            query: ({ messengerId, payload }) => {
                const data = {
                    payload,
                };
                return {
                    path: `${baseUrl}/${messengerId}/decrypt`,
                    method: 'POST',
                    body: data,
                };
            },
        }),
        verifyElevioAccount: builder.query({
            query: ({ accountId }) => ({
                path: `${baseUrl}/elevio-accounts/${accountId}`,
            }),
        }),
        readGlobalFallbackSettings: builder.query({
            query: () => ({
                path: `${baseUrl}/default-settings`,
            }),
        }),
    }),
});
